import $ from "jquery";
import { dataaccess } from "../dataaccess/dataContext";
import { application } from "../application/application";
import { forms } from "../framework/forms";

function init() {
    $(document).on("dblclick", ".manageCourse", function() {
        forms.showSpinner();
        window.location.href =
            application.baseUrl + "/course/index/" + $(this).attr("data-courseId");
    });

    $(document).on("click", ".btnDraftCourseApprove", evtbtnDraftCourseApproveClick);
    $(document).on("click", ".btnCancelDraftCourse", evtbtnCancelDraftCourseClick);
}

function evtbtnDraftCourseApproveClick() {
    $("#ManageDraftCrasLoading").show();
    $(this).attr("disabled", true);
    const row = $(this).closest("tr");
    const courseId = row.attr("data-courseId");
    
    const params = {
        url: "/Course/submitdraftcourse/" + courseId,
        successMsg: "Successfully submitted course."
    };

    dataaccess.post(params).done(function() {
        row.hide();
        updateDraftCourseCount();
        $("#ManageDraftCrasLoading").hide();
    });
}

function evtbtnCancelDraftCourseClick() {
    $("#ManageDraftCrasLoading").show();

    const row = $(this).closest("tr");
    const courseId = row.attr("data-courseId");
    const params = {
        url: "/Course/cancelcourse/" + courseId,
        successMsg: "Successfully canceled course."
    };
    dataaccess.post(params).done(function() {
        row.hide();
        updateDraftCourseCount();
        $("#ManageDraftCrasLoading").hide();
    });
}

function updateDraftCourseCount() {
    let requestsLeft = $("#hdnDraftCoursesCount").val();
    if (requestsLeft > 0) {
        requestsLeft--;
    }
    $("[manageOpenCRAsBadge]").text(!requestsLeft ? "0" : requestsLeft);
    if (requestsLeft || parseInt(requestsLeft) > 0) {
        $("#divNoDraftCourses").addClass("hidden");
        $("#divViewDraftCourses").removeClass("hidden");
        return;
    }
    $("#divNoDraftCourses").removeClass("hidden");
    $("#divViewDraftCourses").addClass("hidden");
}

export const dashboardManageDraftCourses = {
    init: init
};
